import type { Participant } from "@/api/types";

/* Six warm hues — deterministic colour per participant name. NOT tied
 * to identity; just visual differentiation per the design-system
 * direction. Values picked to stay readable on light + dark surfaces. */
const PALETTE = [
  "#FF8A65", // amber
  "#FFB74D", // orange
  "#81C784", // sage
  "#4FC3F7", // sky
  "#9575CD", // lavender
  "#F06292", // rose
] as const;

function hash(str: string): number {
  let h = 5381;
  for (let i = 0; i < str.length; i += 1) {
    h = ((h << 5) + h + str.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function avatarColour(name: string): string {
  return PALETTE[hash(name) % PALETTE.length]!;
}

export function avatarInitials(p: Pick<Participant, "name" | "display_suffix">): string {
  if (p.display_suffix && p.display_suffix.length > 0) {
    return (p.name[0]! + p.display_suffix[0]!).toUpperCase();
  }
  return (p.name[0] ?? "?").toUpperCase();
}

export function participantLabel(p: Pick<Participant, "name" | "display_suffix">): string {
  return p.display_suffix ? `${p.name} ${p.display_suffix}` : p.name;
}
